export const checksums = {
  "blog": "v3.5.0--OK6n_rWQfk2ZK6mk3z0xEC7Lg5ZkYgSPlK-86V7LSn0",
  "page": "v3.5.0--0e58-vybzzhIGqm-apVT_3FdljfnZmgs1CsuoGLmeFw",
  "block": "v3.5.0--GpKUeKuK8JEHcIj72zFNF6yqqXE0qzpP1HZ2eDIKUpw"
}
export const checksumsStructure = {
  "blog": "nE7TvqAYp_ljOBk1xbcT2N0sWfmb3KqeIpa6DSN6Teo",
  "page": "ZJmgK8QpiovvaINnv71xswQP_xqBqR1Xz1V_zRJIfQk",
  "block": "wlTxc0uLLk2cO_h__aLE6l7toE4uL-tdKyV80DwZjv4"
}

export const tables = {
  "blog": "_content_blog",
  "page": "_content_page",
  "block": "_content_block",
  "info": "_content_info"
}

export default {
  "blog": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "approved": "boolean",
      "author": "string",
      "body": "json",
      "category": "string",
      "cover": "string",
      "date": "string",
      "description": "string",
      "downloadUrl": "string",
      "extension": "string",
      "extraTitle": "string",
      "image": "json",
      "meta": "json",
      "navigation": "json",
      "order": "number",
      "path": "string",
      "section_blog": "boolean",
      "section_catalog": "boolean",
      "section_media": "boolean",
      "section_popular": "boolean",
      "section_recommended": "boolean",
      "seo": "json",
      "sortAfterProduct": "string",
      "sortAfterProductFallback": "string",
      "stem": "string"
    }
  },
  "page": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "block": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}